import { Reducer } from 'redux';
import { IDeathsState } from 'types/deaths.types';
import * as authConstants from '../constants/auth.constants';
import * as constants from '../constants/deaths.constants';

export const defaultState: IDeathsState = {
  cementeries: {},
  civilStates: {},
  count: 0,
  idCardTypes: {},
  items: [],
  loading: false,
  selectedItem: null,
  table: {
    page: 1,
    limit: 10,
    search: '',
    sortKey: 'id',
    sortType: 'asc',
  },
  tribes: {},
};

const deathsReducer: Reducer = (state = defaultState, action) => {
  const { data, type } = action;
  switch (type) {
    case constants.DEATHS_ON_DELETE_REQUESTED:
    case constants.DEATHS_ON_GET_ALL_REQUESTED:
    case constants.DEATHS_ON_GET_FORM_REQUESTED:
    case constants.DEATHS_ON_SAVE_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case constants.DEATHS_ON_GET_ONE_REQUESTED:
      return {
        ...state,
        loading: !!action.id,
        selectedItem: null,
      };
    case constants.DEATHS_ON_GET_ALL_SUCCEEDED:
      return {
        ...state,
        count: data.count,
        items: data.items,
        loading: false,
        table: data.table,
      };
    case constants.DEATHS_ON_GET_FORM_SUCCEEDED:
      return {
        ...state,
        cementeries: data.cementeries,
        civilStates: data.civilStates,
        idCardTypes: data.idCardTypes,
        loading: false,
        tribes: data.tribes,
      };
    case constants.DEATHS_ON_GET_ONE_SUCCEEDED:
      return {
        ...state,
        loading: false,
        selectedItem: data.item,
      };
    case constants.DEATHS_ON_DELETE_SUCCEEDED:
    case constants.DEATHS_ON_SAVE_SUCCEEDED:
    case constants.DEATHS_ON_DELETE_FAILED:
    case constants.DEATHS_ON_GET_ALL_FAILED:
    case constants.DEATHS_ON_SAVE_FAILED:
      return {
        ...state,
        loading: false,
      };
    case constants.DEATHS_ON_GET_FORM_FAILED:
      return {
        ...state,
        cementeries: {},
        civilStates: {},
        idCardTypes: {},
        loading: false,
        tribes: {},
      };
    case constants.DEATHS_ON_GET_ONE_FAILED:
      return {
        ...state,
        loading: false,
        selectedItem: null,
      };
    case authConstants.AUTH_ON_LOGOUT_SUCCEEDED:
    case authConstants.AUTH_ON_LOGOUT_PUBLIC_SUCCEEDED:
      return defaultState;
    default:
      return state;
  }
};

export default deathsReducer;
